<template>
  <div class="footer">
    <div class="website">
      <div class="title">系列网站</div>
      <div class="list">
        <el-link
          v-for="item in siteList"
          :key="item.name"
          :underline="false"
          :href="item.src"
          target="_blank"
          >{{ item.name }}</el-link
        >
      </div>
    </div>
    <div class="spe_line"></div>
    <div class="contact">
      <div class="f_logo">
        <img src="@/assets/logo.png" alt="" />
      </div>
      <div class="feedback">意见反馈：zhang.yining@kepuchina.org.cn</div>
      <div class="telephone">联系电话：010-63581721</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      siteList: [
        {
          src: "https://www.kepuchina.cn/",
          name: "科普中国网",
        },
        {
          src: "http://kpzgkjqydst.xinhuanet.com/",
          name: "科技前沿大师谈",
        },
        {
          src: "http://kpzgkxylydt.xinhuanet.com/",
          name: "科学原理一点通",
        },
        {
          src: "http://www.kepu.net.cn/gb/ydrhcz/",
          name: "科普融合创作与传播",
        },
        {
          src: "http://zhihui.kepuchina.cn/",
          name: "智慧女性",
        },

        {
          src: "https://baike.baidu.com/science",
          name: "科学百科",
        },
        {
          src: "http://junshi.gmw.cn/index.htm",
          name: "军事科技前沿",
        },
        {
          src: "http://jysh.people.cn/GB/index.html",
          name: "科学为你解疑释惑",
        },
        {
          src: "http://lxjk.people.cn/GB/index.html",
          name: "乐享健康",
        },
        {
          src: "http://zone.guokr.com/area/scientist-article/",
          name: "我是科学家",
        },
        {
          src: "http://kxdr.bkweek.com/chuangguan/main",
          name: "科学答人",
        },
        {
          src: "http://sci.kpcswa.org.cn/index/",
          name: "科普文创",
        },
        {
          src: "http://video.kepuchina.cn/",
          name: "V视快递",
        },
        {
          src: "https://cloud.kepuchina.cn/",
          name: "科普中国云",
        },
        {
          src: "https://view.inews.qq.com/a/JIQ2020090801528200",
          name: "全民爱科学",
        },
        {
          src: "http://sci-fispace.com/",
          name: "科幻空间",
        },
        // {
        //   src: "https://kxyx.qq.com/",
        //   name: "科学游戏",
        // },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.footer {
  padding: 230px 0 0;
  @include wrap;
  .website {
    float: left;
    width: 790px;
    height: 185px;
    .title {
      font-size: 18px;
      color: #fff;
    }
    .list {
      margin-top: 10px;
      .el-link {
        align-items: inherit;
        justify-content: inherit;
        width: 196px;
        font-size: 16px;
        line-height: 36px;
        color: #949191;
      }
      @include flexBox(null, null, null, wrap);
    }
  }
  .spe_line {
    float: left;
    height: 101px;
    margin-top: 50px;
    margin-right: 60px;
    border-left: 1px solid #979797;
  }

  .contact {
    float: left;
    height: 185px;
    //padding: 40px 0 0 84px;
    .f_logo {
      width: 310px;
      height: 60px;
      margin-top: 30px;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
    .feedback {
      margin: 27px 0 14px;
      font-size: 16px;
      color: #949191;
    }
    .telephone {
      font-size: 16px;
      color: #949191;
    }
  }
}
</style>
